module.exports = __webpack_public_path__ + "img/symbol_1.78a4fa1e.png";